import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import RefreshAds from './RefreshAds';
import safelyEvalAdScript from './safelyEvalAdScript';
import areAdsBypassed from './areAdsBypassed';
import isDevelopment from './isDevelopment';
export default function InsertHeaderAd() {
  const AdCode = app.data['nagusi-ext-ads.ad-code.header'];
  const Script = app.data['nagusi-ext-ads.ad-code.header.js'];
  const dev = isDevelopment();
  const Html = dev ? m("p", null, "Anuncio") : m.trust(AdCode);
  override(IndexPage.prototype, 'hero', function (originalHero) {
    if (areAdsBypassed()) return originalHero();
    return m('[', null, originalHero(), m("div", {
      align: "center",
      class: "nagusi-ad nagusi-ad-header"
    }, Html));
  });
  extend(IndexPage.prototype, ['oncreate', 'onupdate'], function (returned) {
    if (areAdsBypassed() || dev) return;
    RefreshAds();
    safelyEvalAdScript('header', Script);
  });
}